import "./SystemsList.css";
import { SourceType } from "../../../store/ExternalEpmConnectStore";
import { System } from "./common";
import { SystemButton } from "./SystemButton";

type Props = {
    selectedSystem: SourceType;
    systems: System[];
    onSelect: (system: SourceType) => void;
};

const SystemsList = (props: Props) => (
    <div className="system-connect-buttons-list">
        {props.systems.map(_ =>
            <SystemButton
                key={_.type?.toString()}
                system={_}
                isSelected={_.type === props.selectedSystem}
                onSelect={() => props.onSelect(_.type!)} />)}
    </div>
);

export default SystemsList;



